import { CLOSE_INFO, SET_INFO } from "../actions/types";

const INITIAL_STATE = {
    info: '',
    status: 0,
};

const SnackReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case SET_INFO:
            return { ...state, info: action.payload.info, status: action.payload.status }
        case CLOSE_INFO:
            return { ...state, info: '', status: 0, }
        default:
            return state;
    }
};

export default SnackReducer;